// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* StatusBadge.module.css */
.sansSerifFont {
    font-family: sans-serif !important;
}`, "",{"version":3,"sources":["webpack://./src/components/UserOrgSearch/statusBadge.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;IACI,kCAAkC;AACtC","sourcesContent":["/* StatusBadge.module.css */\n.sansSerifFont {\n    font-family: sans-serif !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
